export default {
  getResources(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/resources?category=ca&category_resource=${id}&is_blackwhite=false&limit=1000`
        )
        .then(response => {
          context.commit("setResources", {
            id,
            resources: response.data.results
          });
          resolve();
        })
        .catch(reject);
    });
  },
  getLessons(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons?is_month=false&category=${id}&limit=1000`)
        .then(response => {
          context.commit("setLessons", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getMasterclasses(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons?is_month=true&category=${id}&limit=1000`)
        .then(response => {
          context.commit("setMasterclasses", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getBooks(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/resources?category=ca&is_blackwhite=false&ordering=-created_at&lesson__category=${id}&limit=1000`
        )
        .then(response => {
          context.commit("setBooks", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getLives(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/resources?category=videos&ordering=-created_at&lesson__category=${id}&limit=1000`
        )
        .then(response => {
          context.commit("setLives", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getAudios(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/resources?category=audios&ordering=-created_at&lesson__category=${id}&limit=1000`
        )
        .then(response => {
          context.commit("setAudios", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  }
};
